/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Jpc_FooterInputs */

const es_cap_jpc_footer = /** @type {(inputs: Cap_Jpc_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin penalización por rechazar. Tu valoración no depende de cuántas aceptas.`)
};

const gl_cap_jpc_footer = /** @type {(inputs: Cap_Jpc_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sen penalización por rexeitar. A túa valoración non depende de cantas aceptas.`)
};

const en_cap_jpc_footer = /** @type {(inputs: Cap_Jpc_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No penalty for declining. Your rating is not tied to how many you accept.`)
};

/**
* | output |
* | --- |
* | "No penalty for declining. Your rating is not tied to how many you accept." |
*
* @param {Cap_Jpc_FooterInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const cap_jpc_footer = /** @type {((inputs?: Cap_Jpc_FooterInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Jpc_FooterInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_cap_jpc_footer(inputs)
	if (locale === "en") return en_cap_jpc_footer(inputs)
	return es_cap_jpc_footer(inputs)
});